<template>
  <div
    :id="id"
    class="modal fade"
  >
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <ValidationObserver
          v-slot="{ invalid }"
          :disabled="true"
          v-if="appointment"
        >
          <div class="modal-header">
            <modal-close-button @confirmed="closeModal" />
            <h4 class="modal-title">{{ getModalTitle() }}</h4>
          </div>
          <div class="modal-body">
            <div class="col-xl-12 pr-4">
              <!-- START Stammdaten -->
              <container-headline
                :headline="$t('global.masterdata')"
                :col="6"
              ></container-headline>
              <div class="row mb-3">
                <div class="col-xl-12 block br-t-l-0">
                  <div class="eingabe-panel-kopf p-3">
                    <div class="row">
                      <div class="col-xl-6">
                        <div class="form-group">
                          <ValidationProvider
                            rules="required"
                            immediate
                            v-slot="{ passed }"
                          >
                            <input
                              v-model.trim="appointment.bezeichnung"
                              class="form-control"
                              v-bind:class="{ 'border-danger': !passed }"
                              placeholder=" "
                            />
                            <label v-bind:class="{ 'text-danger': !passed }">
                              {{ $t('global.designation') }}
                            </label>
                          </ValidationProvider>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-xl-6">
                        <div class="form-group">
                          <input
                            type="number"
                            min="1"
                            max="53"
                            v-model.number="appointment.kalenderwoche"
                            class="form-control"
                            placeholder=" "
                          />
                          <label>{{ $t('global.calendar_week') }}</label>
                        </div>
                      </div>
                      <div class="col-xl-6">
                        <div class="form-group">
                          <v-select
                            v-model="appointment.wochentag"
                            :options="weekdays"
                            label="bezeichnung"
                            :placeholder="$t('global.weekday')"
                          >
                            <span slot="no-options">
                              {{ $t('global.taptosearch') }}
                            </span>
                          </v-select>
                          <label>{{ $t('global.weekday') }}</label>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-xl-6">
                        <ValidationProvider
                          rules="required"
                          immediate
                        >
                          <div class="form-group">
                            <div class="input-group">
                              <input
                                type="time"
                                class="form-control"
                                v-model="appointment.von_uhrzeit"
                              />
                              <div
                                class="input-group-append text-medium-light h-100 mr-2 d-flex align-items-center"
                              >
                                <font-awesome-icon
                                  icon="fa-solid fa-clock"
                                  class="m-auto"
                                />
                              </div>
                            </div>
                            <label>{{ $t('global.starttime') }}</label>
                          </div>
                        </ValidationProvider>
                      </div>
                      <div class="col-xl-6">
                        <ValidationProvider
                          rules="required"
                          immediate
                        >
                          <div class="form-group">
                            <div class="input-group">
                              <input
                                type="time"
                                class="form-control"
                                v-model="appointment.bis_uhrzeit"
                              />
                              <div
                                class="input-group-append text-medium-light h-100 mr-2 d-flex align-items-center"
                              >
                                <font-awesome-icon
                                  icon="fa-solid fa-clock"
                                  class="m-auto"
                                />
                              </div>
                            </div>
                            <label>{{ $t('global.endtime') }}</label>
                          </div>
                        </ValidationProvider>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-xl-6">
                        <div class="form-group">
                          <input
                            v-model.number="appointment.lektionen"
                            class="form-control"
                            placeholder=""
                          />
                          <label>
                            {{ $t('global.lessons') }}
                          </label>
                        </div>
                      </div>
                      <div class="col-xl-6">
                        <single-select-person
                          id="termin-reserviert-durch"
                          :person="appointment.reserviert_durch"
                          :label="$t('global.reservedby')"
                          :allowOpen="false"
                          :rollen="filterRollenMitarbeiter"
                          :editable="true"
                          :required="true"
                        />
                      </div>
                    </div>
                    <!-- <div class="row">
                      <div class="col-xl-6">
                        <div class="form-group">
                          <v-select
                            v-model="appointment.ressourcenbuchung"
                            label="bezeichnung"
                            :options="ressourcenbuchungstypen"
                            :placeholder="$t('global.externalinternal')"
                          >
                            <span slot="no-options">
                              {{ $t('global.taptosearch') }}
                            </span>
                          </v-select>
                          <label>{{ $t('global.resourcebooking') }}</label>
                        </div>
                      </div>
                    </div> -->
                    <div class="row">
                      <div class="col-xl-6">
                        <div class="form-group">
                          <!-- v-select für Education -->
                          <v-select
                            v-model="appointment.gebaeude"
                            label="bezeichnung"
                            :options="gebaeude"
                            track-by="id"
                            :placeholder="$t('global.building')"
                            @input="onGebaeudeInput"
                          >
                            <span slot="no-options">
                              {{ $t('global.taptosearch') }}
                            </span>
                          </v-select>
                          <label>{{ $t('global.building') }}</label>
                        </div>
                      </div>

                      <div class="col-xl-6">
                        <div class="form-group">
                          <!-- v-select für Education -->
                          <v-select
                            v-model="appointment.raumliste"
                            label="bezeichnung"
                            :options="filteredRaeume"
                            track-by="id"
                            :placeholder="$t('global.room')"
                            @input="onRaumInput"
                            multiple
                          >
                            <span slot="no-options">
                              {{ $t('global.taptosearch') }}
                            </span>
                          </v-select>
                          <label>{{ $t('global.room') }}</label>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-xl-12">
                        <div class="form-group">
                          <textarea
                            v-model.trim="appointment.bemerkung"
                            class="form-control"
                            placeholder=" "
                            rows="4"
                          ></textarea>
                          <label>{{ $t('global.comment') }}</label>
                        </div>
                      </div>
                    </div>
                    <!-- Start Beschreibung/Details -->
                    <div class="row">
                      <div class="col-xl-12">
                        <div class="form-group">
                          <button
                            type="button"
                            class="btn btn-link p-0"
                            @click="
                              showDescriptionLecturer = !showDescriptionLecturer
                            "
                          >
                            {{ $t('global.showTermindescription_dozierende') }}
                            <span v-if="showDescriptionLecturer">▲</span>
                            <span v-else>▼</span>
                          </button>
                        </div>
                      </div>
                      <div class="col-xl-12">
                        <div
                          class="form-group"
                          v-if="showDescriptionLecturer"
                        >
                          <label>
                            {{ $t('global.termindescription_dozierende') }}
                          </label>
                          <ckeditor
                            :editor="editor"
                            v-model="appointment.bemerkung_lecturer"
                          ></ckeditor>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-xl-12">
                        <div class="form-group">
                          <button
                            type="button"
                            class="btn btn-link p-0"
                            @click="
                              showDescriptionStudents = !showDescriptionStudents
                            "
                          >
                            {{ $t('global.showTermindescription_students') }}
                            <span v-if="showDescriptionStudents">▲</span>
                            <span v-else>▼</span>
                          </button>
                        </div>
                      </div>
                      <div class="col-xl-12">
                        <div
                          class="form-group"
                          v-if="showDescriptionStudents"
                        >
                          <label>
                            {{ $t('global.termindescription_students') }}
                          </label>
                          <ckeditor
                            :editor="editor"
                            v-model="appointment.bemerkung_students"
                          ></ckeditor>
                        </div>
                      </div>
                    </div>
                    <!-- Ende Beschreibung/Details -->
                  </div>
                </div>
              </div>
              <!-- ENDE Stammdaten -->
            </div>
          </div>

          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-default"
              @click="closeModal"
            >
              {{ $t('global.cancel') }}
            </button>
            <button
              type="button"
              :disabled="invalid"
              class="btn btn-primary"
              @click="speichern"
            >
              {{ $t('global.save') }}
            </button>
          </div>
        </ValidationObserver>
      </div>
    </div>
    <loading-overlay v-if="loading"></loading-overlay>
  </div>
</template>

<script>
  import { apiErrorToAlert } from '@/utils/Errorhandler'
  import ContainerHeadline from '@/components/ContainerHeadline'
  import ModalCloseButton from '@/components/global/ModalCloseButton'
  import SingleSelectPerson from '@/components/global/SingleSelectPerson.vue'
  import LoadingOverlay from '@/components/global/LoadingOverlay'
  import ClassicEditor from '/custom/custom_ckeditor/build/ckeditor'
  import { LADE_AUSWAHLWERTE_RESSOURCEN } from '@/store/ressourcen/actions.type'
  import AppApi from '@/api/AppApi'

  export default {
    name: 'NeueTerminvorlageModal',
    components: {
      ContainerHeadline,
      ModalCloseButton,
      SingleSelectPerson,
      LoadingOverlay,
    },
    props: {
      canOpenAppointment: {
        type: Boolean,
        default: false,
      },
      canEditAppointment: {
        type: Boolean,
        default: false,
      },
      singleSelectVeranstaltungId: {
        type: String,
        required: true,
      },
      von: {
        type: String,
        required: false,
        default: () => new Intl.DateTimeFormat('de-CH').format(new Date()),
      },
      bis: {
        type: String,
        required: false,
        default: () => new Intl.DateTimeFormat('de-CH').format(new Date()),
      },
      id: {
        type: String,
        required: true,
      },
      veranstaltung: {
        type: Object,
        required: false,
        default: null,
      },
      raum: {
        type: String,
        required: false,
        default: null,
      },
      planungsstati: {
        type: Array,
        required: true,
      },
      durchfuehrungsstati: {
        type: Array,
        required: true,
      },
      call_getTermine_method: {
        type: Boolean,
        default: true,
      },
      reload_page_data_after_saving: {
        type: Boolean,
        default: false,
      },
      alternatingModalTitle: {
        type: String,
        default: null,
      },
    },
    data() {
      return {
        loading: false,
        shown: false,
        new: true,
        appointment: null,
        initialPlanungsStatusID: '17574932559',
        initialDurchfuehrungsStatusID: '175748EC2CB',
        filterRollenDozenten: this.$CONST('ROLLEN').DOZENTEN,
        filterRollenMitarbeiter: this.$CONST('ROLLEN').MITARBEITER,
        currentconflicts: [],
        appointmentChanged: false,
        showDescriptionLecturer: true,
        showDescriptionStudents: true,
        editor: ClassicEditor,
      }
    },
    computed: {
      weekdays: {
        get() {
          return this.$store.state.ressourcen.wochentage
        },
      },
      ressourcenbuchungstypen: {
        get() {
          return this.$store.state.ressourcen.ressourcenbuchungstypen
        },
      },
      raeume: {
        get() {
          return this.$store.state.ressourcen.raeume
        },
      },
      ressourcenstati: {
        get() {
          return this.$store.state.ressourcen.ressourcenstati
        },
      },
      mitarbeiter: {
        get() {
          return this.$store.state.mitarbeiter
        },
      },
      gebaeude: {
        get() {
          return this.$store.state.ressourcen.gebaeude
        },
      },
      filteredRaeume() {
        if (!this.appointment) return this.raeume
        const gebId =
          typeof this.appointment.gebaeude === 'object'
            ? this.appointment.gebaeude?.id
            : this.appointment.gebaeude
        if (!gebId) return this.raeume
        return this.raeume.filter((r) => r.gebaeude?.id === gebId)
      },
    },
    watch: {
      planungsstati(newVal) {
        if (newVal.length > 0) {
          this.getInitialPlanungsStatus()
        }
      },
      durchfuehrungsstati(newVal) {
        if (newVal.length > 0) {
          this.getInitialDurchfuehrungsStatus()
        }
      },
    },
    mounted() {
      if (this.ressourcenstati.length == 0 || this.weekdays.length == 0) {
        this.$store.dispatch(`ressourcen/${LADE_AUSWAHLWERTE_RESSOURCEN}`)
      }
      this.$bus.$on(
        'openNeueTerminvorlageModal:new',
        (id, appointment = null) => {
          if (id === this.id && !this.shown) this.openModal(id, appointment)
        }
      )
      this.$bus.$on(
        'openNeueTerminvorlagenModal:edit',
        (id, appointment = null) => {
          if (id === this.id && !this.shown) this.openModal(id, appointment)
        }
      )
    },
    methods: {
      defaultAppointment() {
        return {
          id: null,
          bezeichnung: null,
          bemerkung: null,
          bemerkung_students: null,
          bemerkung_lecturer: null,
          wochentag: null,
          kalenderwoche: null,
          von_uhrzeit: null,
          bis_uhrzeit: null,
          ressourcenbuchung: this.$CONST('RESSOURCENBUCHUNGEN').INTERNAL,
          ressourcenstatus: this.$CONST('RESSOURCENSTATI').RESERVED,
          lektionen: null,
          planungsstatus: null,
          durchfuehrungsstatus: null,
          gebaeude: null,
          raumliste: [],
          reserviert_durch: null,
          veranstaltung: this.veranstaltung.id ?? null,
        }
      },
      getModalTitle() {
        return this.$t(
          this.new
            ? 'global.createnewappointment'
            : 'global.editAppointmentDetails'
        )
      },
      getInitialPlanungsStatus() {
        this.appointment.planungsstatus =
          this.planungsstati.find(
            (s) => s.id === this.initialPlanungsStatusID
          ) || null
      },
      getInitialDurchfuehrungsStatus() {
        this.appointment.durchfuehrungsstatus =
          this.durchfuehrungsstati.find(
            (s) => s.id === this.initialDurchfuehrungsStatusID
          ) || null
      },
      openModal(id, appointment = null) {
        this.shown = true
        const thisId = id || this.id
        this.new = !appointment

        const base = appointment ? appointment : this.defaultAppointment()
        // tief klonen, um Seiteneffekte zu vermeiden
        this.appointment = JSON.parse(JSON.stringify(base))

        if (!this.appointment.reserviert_durch) {
          this.appointment.reserviert_durch = this.mitarbeiter.person
        }

        $('#' + thisId).modal({ backdrop: 'static', keyboard: false })
      },

      speichern() {
        if (this.loading) return
        this.loading = true

        const src = this.appointment
        const json = {
          ...src,
          reserviert_durch:
            src.reserviert_durch?.id ?? src.reserviert_durch ?? null,
          gebaeude:
            (typeof src.gebaeude === 'object'
              ? src.gebaeude?.id
              : src.gebaeude) ?? null,
          raumliste: (src.raumliste || [])
            .map((r) => (typeof r === 'object' ? r?.id : r))
            .filter(Boolean),
          wochentag: src.wochentag?.id ?? src.wochentag ?? null,
          ressourcenbuchung:
            src.ressourcenbuchung?.id ?? src.ressourcenbuchung ?? null,
          konfliktstatus: src.konfliktstatus?.id ?? src.konfliktstatus ?? null,
          verantwortlich: src.verantwortlich?.id ?? src.verantwortlich ?? null,
          veranstaltung: this.veranstaltung.id ?? null,
        }
        if (this.new) delete json.id

        const req = this.new
          ? AppApi.post('terminvorlage/', json)
          : AppApi.put('terminvorlage/', json)

        req
          .then(() => {
            this.$notify({
              type: 'success',
              title: this.$t('global.actionsuccessful'),
              text: this.new
                ? this.$t('global.appointmentsuccessfullycreated')
                : this.$t('global.appointmentsuccessfullyupdated'),
            })
            this.call_getTermine_method && this.$parent.getTermine()
            this.reload_page_data_after_saving && this.$parent.reloadPageData()
            this.closeModal()
          })
          .catch((e) => this.$notify(apiErrorToAlert(e)))
          .finally(() => {
            this.loading = false
          })
      },

      onGebaeudeInput(geb) {
        // v-select liefert ein Gebäude-Objekt oder null
        this.appointment.gebaeude = geb || null
        const gebId = geb?.id
        if (!gebId) return

        // raumliste enthält Raum-Objekte → nach Gebäude filtern
        this.appointment.raumliste = (this.appointment.raumliste || []).filter(
          (r) => r?.gebaeude?.id === gebId
        )
      },

      onRaumInput(selected) {
        // v-select multiple liefert ein Array von Raum-Objekten
        const rooms = (Array.isArray(selected) ? selected : [selected]).filter(
          Boolean
        )
        this.appointment.raumliste = rooms

        // akt. Gebäude-ID ermitteln (Objekt oder ID möglich)
        let gebId =
          typeof this.appointment.gebaeude === 'object'
            ? this.appointment.gebaeude?.id
            : this.appointment.gebaeude

        // Wenn noch kein Gebäude gesetzt: automatisch setzen, wenn alle Räume dasselbe Gebäude haben
        if (!gebId && rooms.length) {
          const uniqueGebIds = [
            ...new Set(rooms.map((r) => r?.gebaeude?.id).filter(Boolean)),
          ]
          if (uniqueGebIds.length === 1) {
            gebId = uniqueGebIds[0]
            // Gebäude im State als Objekt halten (bevorzugt)
            const gebObj = this.gebaeude.find((g) => g.id === gebId)
            this.appointment.gebaeude = gebObj || { id: gebId }
          }
        }

        // Wenn Gebäude gesetzt: nur passende Räume behalten
        if (gebId) {
          this.appointment.raumliste = rooms.filter(
            (r) => r?.gebaeude?.id === gebId
          )
        }
      },

      closeModal() {
        this.shown = false
        $('#' + this.id).modal('hide')
        this.appointment = this.defaultAppointment()
        this.showDescriptionLecturer = false
        this.showDescriptionStudents = false
      },

      acceptConflict() {},
      setConflictStatus() {},

      //TODO is this still required? jupp
      openTermin(terminId) {
        // open termin in new tab
        const url = this.$router.resolve({
          name: 'termin',
          params: { id: terminId, anzeige: 0 },
        }).href
        window.open(url, '_blank')
      },
    },
  }
</script>

<style></style>
